module.exports = __webpack_public_path__ + "static/media/015.a793c6da.jpg";